import {
  FunctionComponent,
  useEffect,
  useMemo,
  useCallback,
  useState,
} from "react";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
// import useDebitor from "~/hooks/useDebitor";
import usePartner from "~/hooks/usePartner";
import useOperation from "~/hooks/useOperation";
import {
  getPartnersAPI,
  IPartner,
  postPartnerBankAccountAPI,
} from "~/services/api/partner";
import { getBankAccountsAPI, IBankAccount } from "~/services/api/bankAccount";
import {
  Button,
  // Button,
  Checkbox,
  Input,
  InputSelect,
  // Tooltip,
} from "prosperita-dumbo-react";
// import NewDebitorIcon from "~/assets/new-debitor.png";
// import ArrowIcon from "~/assets/arrow-right-_1_.png";
import { getLabelByValue, onlyNumbers, zIndex } from "~/services/utils";
import Margin from "~/components/Margin";
import CloseIcon from "~/assets/Close--outline.png";
import useLoading from "~/hooks/useLoading";
import LateralModal from "~/components/LateralModal";
import SaveIcon from "~/assets/Save.png";
import { toast } from "react-toastify";
import { banksOptions } from "~/utils/banks";
import documentNumberValidator from "~/services/validateDocumentNumber";
// import ArrowLeft from "~/assets/arrow-lftt-_1_.png";
// import WhiteLeft from "~/assets/white-left.png";

const Footer = styled.div`
  width: 90%;
  position: fixed;
  bottom: 0;
  display: grid;
  padding-bottom: 50px;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
`;

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; // se precisar voltar o adicionar contato só colocar o auto
  gap: 32px;
  row-gap: 30px;
  margin-top: 20px;
`;

type IInitialValues = {
  debtor_uuid: string;
  invoice_barcode: string;
  assignor_uuid: string;
  liquidation_bank_account_uuid: string;
  liquidation_type: string;
  receivables_register: boolean;
  batch_assignment: boolean;
  details: string;
  pix_key: string;
  pix_key_type: string;
  agency: string;
  agency_digit: string;
  account_number: string;
  account_number_digit: string;
  bank_identification_code: string;
};

const ProductInfoCCB: FunctionComponent = () => {
  // const { setOpenNewDebitorModal } = useDebitor();
  const location = useLocation();
  const {
    setPartners,
    partners,
    setBankAccounts,
    bankAccounts,
    addBankAccounts,
    setAddBankAccounts,
  } = usePartner();
  const { setPayloadOperation, setTab, setCanAdvance } = useOperation();
  const { setLoading } = useLoading();
  // const navigate = useNavigate();
  // const [hover, setHover] = useState<boolean>(false);
  const [partnersFidc, setPartnersFidc] = useState<IPartner[]>();
  const initialValues = useMemo(() => {
    const storedOperation = localStorage.getItem("@:operation");
    const defaultValues: IInitialValues = {
      debtor_uuid: "",
      assignor_uuid: "",
      invoice_barcode: "",
      liquidation_bank_account_uuid: "",
      liquidation_type: "",
      receivables_register: false,
      batch_assignment: false,
      details: "",
      pix_key: "",
      pix_key_type: "",
      agency: "",
      agency_digit: "",
      account_number: "",
      account_number_digit: "",
      bank_identification_code: "",
    };

    if (storedOperation) {
      try {
        const parsedOperation = JSON.parse(storedOperation);
        // Se for "pix", infere se é chave ou conta bancária baseado no pix_key_type
        let liquidationType = parsedOperation.liquidation_type;
        if (liquidationType === "pix") {
          // Se pix_key_type é "bank_account", é conta bancária
          if (parsedOperation.pix_key_type === "bank_account") {
            liquidationType = "pix_bank_account";
          } else if (parsedOperation.pix_key && parsedOperation.pix_key_type) {
            liquidationType = "pix_key";
          } else {
            liquidationType = "pix_key"; // Padrão
          }
        }
        return {
          debtor_uuid: parsedOperation.debtor_uuid,
          assignor_uuid: parsedOperation.assignor_uuid,
          liquidation_bank_account_uuid:
            parsedOperation.liquidation_bank_account_uuid,
          liquidation_type: liquidationType,
          receivables_register: parsedOperation.receivables_register,
          batch_assignment: parsedOperation.batch_assignment,
          details: parsedOperation.details,
          invoice_barcode: parsedOperation.invoice_barcode,
          pix_key: parsedOperation.pix_key,
          // Se for pix_bank_account, não carrega o pix_key_type (será definido como "bank_account" automaticamente)
          pix_key_type: liquidationType === "pix_bank_account" ? "" : parsedOperation.pix_key_type,
          agency: "",
          agency_digit: "",
          account_number: "",
          account_number_digit: "",
          bank_identification_code: "",
        };
      } catch (error) {
        console.error("Erro ao parsear o localStorage:", error);
      }
    }

    return defaultValues;
  }, []);

  const { values, setFieldValue } = useFormik({
    initialValues,
    onSubmit: () => undefined,
  });

  const handleSelect = useCallback(
    (fieldName: keyof IInitialValues, selectedOption) => {
      if (selectedOption) {
        setFieldValue(fieldName, selectedOption.value);
      }
    },
    [setFieldValue]
  );

  const handleSelectTypeKeyPix = useCallback(
    (fieldName: keyof IInitialValues, selectedOption) => {
      if (selectedOption) {
        setFieldValue("pix_key", "");
        setFieldValue(fieldName, selectedOption.value);
      }
    },
    [setFieldValue]
  );

  const fetchPartnersUY3 = useCallback(async (): Promise<void> => {
    try {
      const { data } = await getPartnersAPI();
      setPartners(data.payload);
    } catch (e) {
      console.log(e);
    }
  }, [setPartners]);

  const fetchPartnersFIDC = useCallback(async (): Promise<void> => {
    try {
      const { data } = await getPartnersAPI({
        label: "uy3",
        legal_nature: "fidc",
      });
      setPartnersFidc(data.payload);
    } catch (e) {
      console.log(e);
    }
  }, [setPartnersFidc]);

  const fetchBankAccounts = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const { data } = await getBankAccountsAPI(values.debtor_uuid);
      setBankAccounts(data.payload);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }, [values.debtor_uuid, setBankAccounts, setLoading]);

  const partnersDebtor = useMemo(() => {
    return partners
      .map((partner: IPartner) => ({
        value: partner.uuid,
        label: partner.name,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, [partners]);

  const partnersAssignor = useMemo(() => {
    return partnersFidc
      ?.map((partner: IPartner) => ({
        value: partner.uuid,
        label: partner.name,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, [partnersFidc]);

  const formatCPF = (value: string): string => {
    value = value.replace(/\D/g, "").slice(0, 11); // <-- limita a 11 dígitos
    return value
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  };

  const formatCNPJ = (value: string): string => {
    value = value.replace(/\D/g, "");
    if (value.length <= 2) return value;
    if (value.length <= 5) return `${value.slice(0, 2)}.${value.slice(2)}`;
    if (value.length <= 8)
      return `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5)}`;
    if (value.length <= 12)
      return `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8)}`;
    return `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12, 14)}`;
  };

  const formatPhone = (value: string): string => {
    value = value.replace(/\D/g, "");
    if (value.length <= 2) return `(${value}`;
    if (value.length <= 6) return `(${value.slice(0, 2)}) ${value.slice(2)}`;
    return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
  };

  const handlePixKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    let formattedValue = rawValue;

    switch (values.pix_key_type) {
      case "document_number_cpf":
        formattedValue = formatCPF(rawValue);
        break;
      case "document_number_cnpj":
        formattedValue = formatCNPJ(rawValue);
        break;
      case "phone":
        formattedValue = formatPhone(rawValue);
        break;
      default:
        formattedValue = rawValue;
    }

    setFieldValue("pix_key", formattedValue);
  };

  const banks = banksOptions.map((item) => ({
    value: `${item.code}/*?${item.name}`,
    label: item.name,
  }));

  const handleClose = useCallback(() => {
    setAddBankAccounts(false);

    setFieldValue("agency", "");
    setFieldValue("agency_digit", "");
    setFieldValue("account_number", "");
    setFieldValue("account_number_digit", "");
    setFieldValue("bank_identification_code", "");
  }, [setAddBankAccounts, setFieldValue]);

  const createBankAccount = useCallback(async () => {
    const payload = {
      agency: values.agency,
      agency_digit: values.agency_digit,
      account_number: values.account_number,
      account_number_digit: values.account_number_digit,
      bank_code: values.bank_identification_code.split("/*?")[0],
      partner_uuid: values.debtor_uuid,
    };
    setLoading(true);

    try {
      await postPartnerBankAccountAPI(payload);

      toast.success("Conta bancária adicionada com sucesso");
      handleClose();

      fetchBankAccounts();
      setLoading(false);
    } catch (e) {
      console.log(e);

      toast.error(
        "Não foi possível adicionar a conta bancária. Tente novamente"
      );
      setLoading(false);
    }
  }, [values, setLoading, fetchBankAccounts, handleClose]);

  const isValidCPF = useMemo(() => {
    return (
      values.pix_key_type === "document_number_cpf" &&
      onlyNumbers(values.pix_key).length > 10 &&
      documentNumberValidator(values.pix_key)
    );
  }, [values]);

  const isValidCNPJ = useMemo(() => {
    return (
      values.pix_key_type === "document_number_cnpj" &&
      onlyNumbers(values.pix_key).length > 13 &&
      documentNumberValidator(values.pix_key)
    );
  }, [values]);

  const validateEmail = useCallback((email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }, []);

  const [showRequiredErrors, setShowRequiredErrors] = useState(false);

  const hasFormErrors = useMemo(() => {
    // Validações para PIX com chave
    const pixKeyErrors = values.liquidation_type === "pix_key" && (
      !values.pix_key_type ||
      !values.pix_key ||
      (values.pix_key_type === "phone" && onlyNumbers(values.pix_key).length < 11) ||
      (values.pix_key_type === "email" && !validateEmail(values.pix_key)) ||
      (values.pix_key_type === "document_number_cpf" && onlyNumbers(values.pix_key).length < 11) ||
      (values.pix_key_type === "document_number_cnpj" && onlyNumbers(values.pix_key).length < 14) ||
      (values.pix_key_type === "document_number_cnpj" && onlyNumbers(values.pix_key).length === 14 && !isValidCNPJ) ||
      (values.pix_key_type === "document_number_cpf" && onlyNumbers(values.pix_key).length === 11 && !isValidCPF)
    );

    return (
      values.debtor_uuid === "" ||
      !values.liquidation_type ||
      (values.liquidation_type === "billet" && values.invoice_barcode === "") ||
      // Para TED e PIX com conta bancária, precisa de conta bancária
      ((values.liquidation_type === "ted" || values.liquidation_type === "pix_bank_account") && !values.liquidation_bank_account_uuid) ||
      pixKeyErrors
    );
  }, [values, isValidCNPJ, isValidCPF, validateEmail]);

  const validateAndAdvance = useCallback((): boolean => {
    setShowRequiredErrors(true);
    
    if (hasFormErrors) {
      // Encontrar o primeiro campo com erro e focar nele
      const fieldIds = [
        "debtor_uuid",
        "liquidation_type",
        "invoice_barcode",
        "liquidation_bank_account_uuid",
        "pix_key_type",
        "pix_key",
      ];
      
      for (const fieldId of fieldIds) {
        const element = document.getElementById(fieldId) || 
                       document.querySelector(`[name="${fieldId}"]`);
        if (element) {
          (element as HTMLElement).focus();
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          break;
        }
      }
      
      return false;
    }
    
    return true;
  }, [hasFormErrors]);

  // Expor a função de validação globalmente para o componente pai acessar
  useEffect(() => {
    (window as any).validateProductInfoCCB = validateAndAdvance;
    return () => {
      delete (window as any).validateProductInfoCCB;
    };
  }, [validateAndAdvance]);

  // Sempre permitir avançar na página product-info (validação será feita no clique)
  useEffect(() => {
    if (location.pathname.includes("product-info")) {
      setCanAdvance(true);
    }
  }, [setCanAdvance, location.pathname]);

  const bankAccountOptions = useMemo(() => {
    return bankAccounts
      .map((bankAccount: IBankAccount) => ({
        value: bankAccount.uuid,
        label: `${bankAccount.bank_name} - Agência: ${bankAccount.agency}${bankAccount.agency_digit ? `-${bankAccount.agency_digit}` : ""} Conta: ${bankAccount.account_number}-${bankAccount.account_number_digit}`,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, [bankAccounts]);

  const liquidationTypeOptions = useMemo(() => {
    return [
      { value: "pix_key", label: "Pix (Chave)" },
      { value: "pix_bank_account", label: "Pix (Conta bancária)" },
      { value: "billet", label: "Boleto" },
      { value: "ted", label: "TED" },
    ].sort((a, b) =>
      a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
    );
  }, []);

  const typeKeyPixOptions = useMemo(() => {
    return [
      { value: "document_number_cpf", label: "CPF" },
      { value: "document_number_cnpj", label: "CNPJ" },
      { value: "phone", label: "Celular" },
      { value: "email", label: "Email" },
      { value: "evp", label: "Chave Aleatória" },
    ];
  }, []);

  useEffect(() => {
    if (values.debtor_uuid !== "") {
      fetchBankAccounts();
    }
  }, [values.debtor_uuid, fetchBankAccounts]);

  useEffect(() => {
    // Sempre salva como "pix" no localStorage, mas mantém os campos para diferenciar
    const liquidationTypeForStorage = 
      values.liquidation_type === "pix_key" || values.liquidation_type === "pix_bank_account"
        ? "pix"
        : values.liquidation_type;

    // Define pix_key_type como "bank_account" quando for PIX conta bancária
    let pixKeyTypeForStorage = values.pix_key_type;
    if (values.liquidation_type === "pix_bank_account") {
      pixKeyTypeForStorage = "bank_account";
    }

    const operationData = {
      debtor_uuid: values.debtor_uuid,
      assignor_uuid: values.assignor_uuid,
      liquidation_bank_account_uuid: values.liquidation_bank_account_uuid,
      liquidation_type: liquidationTypeForStorage, // Sempre "pix" quando for PIX
      receivables_register: values.receivables_register,
      batch_assignment: values.batch_assignment,
      details: values.details,
      invoice_barcode: values.invoice_barcode,
      pix_key_type: pixKeyTypeForStorage, // "bank_account" quando for conta bancária
      pix_key: values.pix_key,
    };

    localStorage.setItem("@:operation", JSON.stringify(operationData));
    
    // Para o contexto, mantém o valor original para controle da UI
    setPayloadOperation({
      ...operationData,
      liquidation_type: values.liquidation_type,
    });
  }, [values, setPayloadOperation]);

  useEffect(() => {
    if (values.liquidation_type !== "billet") {
      setFieldValue("invoice_barcode", "");
    }

    // Limpa campos de chave pix quando não for pix_key
    if (values.liquidation_type !== "pix_key") {
      // Se mudar para pix_bank_account, não limpa o pix_key_type aqui (será definido como "bank_account" no save)
      // Se mudar para outro tipo que não seja pix, limpa tudo
      if (values.liquidation_type !== "pix_bank_account") {
        setFieldValue("pix_key_type", "");
      }
      setFieldValue("pix_key", "");
    }

    // Limpa conta bancária quando for pix_key
    if (values.liquidation_type === "pix_key") {
      setFieldValue("liquidation_bank_account_uuid", "");
      // Limpa pix_key_type quando muda para pix_key (usuário vai selecionar depois)
      setFieldValue("pix_key_type", "");
    }
  }, [values.liquidation_type, setFieldValue]);

  useEffect(() => {
    if (values.debtor_uuid !== "") {
      setFieldValue("liquidation_bank_account_uuid", "");
    }
  }, [values.debtor_uuid, setFieldValue]);

  useEffect(() => {
    fetchPartnersFIDC();
    fetchPartnersUY3();
    setTab(1);
  }, [fetchPartnersUY3, setTab, fetchPartnersFIDC]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <div>
        <InputSelect
          name="assignor_uuid"
          kind="default"
          size="small"
          label="Cessionário"
          options={partnersAssignor}
          placeholder={
            values.assignor_uuid
              ? getLabelByValue(values.assignor_uuid, partnersDebtor)
              : "Selecione uma opção"
          }
          onChange={(e) => handleSelect("assignor_uuid", e)}
        />
      </div>
      <div>
        <InputSelect
          name="debtor_uuid"
          id="debtor_uuid"
          kind="default"
          size="small"
          label="Tomador"
          options={partnersDebtor}
          placeholder={
            values.debtor_uuid
              ? getLabelByValue(values.debtor_uuid, partnersDebtor)
              : "Selecione uma opção"
          }
          error={showRequiredErrors && !values.debtor_uuid}
          message={
            showRequiredErrors && !values.debtor_uuid
              ? "Campo obrigatório"
              : ""
          }
          onChange={(e) => {
            handleSelect("debtor_uuid", e);
            location.reload();
          }}
        />
      </div>
      <div>
        <InputSelect
          name="liquidation_type"
          id="liquidation_type"
          kind="default"
          size="small"
          label="Tipo de liquidação"
          options={liquidationTypeOptions}
          placeholder={
            values.liquidation_type
              ? getLabelByValue(values.liquidation_type, liquidationTypeOptions)
              : "Selecione uma opção"
          }
          error={showRequiredErrors && !values.liquidation_type}
          message={
            showRequiredErrors && !values.liquidation_type
              ? "Campo obrigatório"
              : ""
          }
          onChange={(e) => handleSelect("liquidation_type", e)}
        />
      </div>
      {values.liquidation_type === "billet" && (
        <Input
          name="invoice_barcode"
          id="invoice_barcode"
          size="large"
          value={values.invoice_barcode}
          type="text"
          max={100}
          maxLength={100}
          label="Código de barras do boleto"
          placeholder="Digite"
          error={showRequiredErrors && !values.invoice_barcode}
          message={
            showRequiredErrors && !values.invoice_barcode
              ? "Campo obrigatório"
              : ""
          }
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");

            setFieldValue("invoice_barcode", value);
          }}
        />
      )}
      {/* <div
        style={{
          position: "relative",
          top: "23px",
        }}
      >
        <Tooltip align="top-right" size="medium" label="Adicionar contato">
          {" "}
          <Button
            size="medium"
            kind="tertiary"
            icon={NewDebitorIcon}
            onClick={() => setOpenNewDebitorModal(true)}
          />
        </Tooltip>
      </div> */}
      {/* Mostra conta bancária para TED, Boleto e PIX com conta bancária */}
      {(values.liquidation_type === "ted" ||
        values.liquidation_type === "billet" ||
        values.liquidation_type === "pix_bank_account") && (
        <div>
          <InputSelect
            name="liquidation_bank_account_uuid"
            id="liquidation_bank_account_uuid"
            kind="default"
            size="small"
            label="Conta de liquidação"
            options={bankAccountOptions}
            onChange={(e) => handleSelect("liquidation_bank_account_uuid", e)}
            placeholder={
              bankAccountOptions.length > 0 &&
              values.debtor_uuid &&
              values.liquidation_bank_account_uuid
                ? getLabelByValue(
                    values.liquidation_bank_account_uuid,
                    bankAccountOptions
                  )
                : !values.debtor_uuid
                  ? "Primeiro selecione um tomador"
                  : bankAccountOptions.length <= 0 && values.debtor_uuid
                    ? "O tomador não possui conta bancária"
                    : "Selecione uma opção"
            }
            disabled={bankAccountOptions.length <= 0}
            error={
              showRequiredErrors &&
              (values.liquidation_type === "ted" || values.liquidation_type === "pix_bank_account" || values.liquidation_type === "billet") &&
              !values.liquidation_bank_account_uuid &&
              values.debtor_uuid &&
              bankAccountOptions.length > 0
            }
            message={
              showRequiredErrors &&
              (values.liquidation_type === "ted" || values.liquidation_type === "pix_bank_account" || values.liquidation_type === "billet") &&
              !values.liquidation_bank_account_uuid &&
              values.debtor_uuid &&
              bankAccountOptions.length > 0
                ? "Campo obrigatório"
                : ""
            }
          />
          {values.debtor_uuid && (
            <p
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => setAddBankAccounts(true)}
            >
              Adicionar conta bancária
            </p>
          )}
        </div>
      )}
      {/* Mostra campos de chave PIX apenas quando for pix_key */}
      {values.liquidation_type === "pix_key" && (
        <div>
          <InputSelect
            name="pix_key_type"
            id="pix_key_type"
            kind="default"
            size="small"
            label="Tipo de chave"
            options={typeKeyPixOptions}
            onChange={(e) => handleSelectTypeKeyPix("pix_key_type", e)}
            placeholder={
              values.pix_key_type
                ? getLabelByValue(values.pix_key_type, typeKeyPixOptions)
                : "Selecione uma opção"
            }
            error={showRequiredErrors && values.liquidation_type === "pix_key" && !values.pix_key_type}
            message={
              showRequiredErrors && values.liquidation_type === "pix_key" && !values.pix_key_type
                ? "Campo obrigatório"
                : ""
            }
          />
        </div>
      )}
      {values.pix_key_type && values.liquidation_type === "pix_key" && (
        <Input
          size="large"
          name="pix_key"
          id="pix_key"
          label="* Chave Pix"
          error={
            (showRequiredErrors && values.liquidation_type === "pix_key" && !values.pix_key) ||
            (showRequiredErrors &&
              values.liquidation_type === "pix_key" &&
              values.pix_key_type === "phone" &&
              onlyNumbers(values.pix_key).length < 11) ||
            (showRequiredErrors &&
              values.liquidation_type === "pix_key" &&
              values.pix_key_type === "email" &&
              values.pix_key &&
              !validateEmail(values.pix_key)) ||
            (values.pix_key_type === "document_number_cpf" &&
              onlyNumbers(values.pix_key).length === 11 &&
              !isValidCPF) ||
            (values.pix_key_type === "document_number_cnpj" &&
              onlyNumbers(values.pix_key).length === 14 &&
              !isValidCNPJ)
          }
          message={
            showRequiredErrors && values.liquidation_type === "pix_key" && !values.pix_key
              ? "Campo obrigatório"
              : showRequiredErrors &&
                  values.liquidation_type === "pix_key" &&
                  values.pix_key_type === "phone" &&
                  onlyNumbers(values.pix_key).length < 11
                ? "Digite um telefone válido"
                : showRequiredErrors &&
                    values.liquidation_type === "pix_key" &&
                    values.pix_key_type === "email" &&
                    values.pix_key &&
                    !validateEmail(values.pix_key)
                  ? "Digite um email válido"
                  : values.pix_key_type === "document_number_cpf" &&
                      onlyNumbers(values.pix_key).length === 11 &&
                      !isValidCPF
                    ? "CPF Inválido"
                    : values.pix_key_type === "document_number_cnpj" &&
                        onlyNumbers(values.pix_key).length === 14 &&
                        !isValidCNPJ
                      ? "CNPJ Inválido"
                      : ""
          }
          placeholder={
            values.pix_key_type === "document_number_cpf"
              ? "000.000.000-00"
              : values.pix_key_type === "document_number_cnpj"
                ? "00.000.000/0000-00"
                : values.pix_key_type === "phone"
                  ? "(00) 00000-0000"
                  : "Digite sua chave Pix"
          }
          value={values.pix_key}
          onChange={(e) => handlePixKeyChange(e)}
        />
      )}
      <div
        style={{
          position: "relative",
          top: "32px",
          display: "flex",
          justifyContent: "start",
        }}
      >
        <Checkbox
          label="Registradora de recebiveis"
          checked={values.receivables_register}
          onChange={() =>
            setFieldValue("receivables_register", !values.receivables_register)
          }
        />
        <Checkbox
          label="Cessão em lote"
          checked={values.batch_assignment}
          onChange={() =>
            setFieldValue("batch_assignment", !values.batch_assignment)
          }
        />
      </div>
      <div
        style={{
          position: "relative",
          top: "23px",
        }}
      ></div>
      <div style={{ gridColumn: "1 / -1" }}>
        <Margin mt={values.liquidation_type !== "" ? 0 : 25} />
        <Input
          name="details"
          type="textarea"
          rows={5}
          max={500}
          maxLength={500}
          value={values.details}
          onChange={(e) => setFieldValue("details", e.target.value)}
          label="Observações (Opcional)"
          placeholder="Observações adicionais"
        />
      </div>
      <div
        style={{
          gridColumn: "1 / -1",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {/* <div>
          <Button
            kind="ghost"
            size="large"
            label="Cancelar"
            onClick={() => navigate("/app/credit/operations/")}
          />
        </div> */}
        <div style={{ display: "flex", gap: "10px" }}>
          {/* <div>
            <Button
              kind="tertiary"
              size="large"
              label="Voltar"
              icon={ArrowLeftIcon}
            />
          </div> */}
          {/* <div style={{ display: "flex", gap: "10px" }}>
            <div
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <Button
                kind="tertiary"
                size="large"
                icon={hover ? WhiteLeft : ArrowLeft}
                label="Voltar"
                onClick={() => {
                  navigate("/app/credit/operations/new/ccb/operation");
                  setTab(0);
                }}
              />
            </div>
            <Button
              kind="primary"
              size="large"
              label="Avançar"
              disabled={
                (values.liquidation_type === "billet" &&
                  values.invoice_barcode === "") ||
                values.assignor_uuid === "" ||
                values.debtor_uuid === "" ||
                values.liquidation_bank_account_uuid === "" ||
                values.liquidation_type === ""
              }
              icon={ArrowIcon}
              onClick={() => {
                navigate("/app/credit/operations/new/ccb/involveds/");
                setTab(2);
              }}
            />
          </div> */}
        </div>
      </div>
      <Margin mt={70} />
      <div style={{ zIndex: zIndex }}>
        <LateralModal
          open={addBankAccounts}
          title="Adicionar conta bancária"
          header
          toggleModal={() => {
            handleClose();
          }}
        >
          <div style={{ padding: "20px" }}>
            <InputSelect
              label="Banco"
              kind="default"
              name="bank_identification_code"
              size="small"
              onChange={(e) =>
                setFieldValue("bank_identification_code", e.value)
              }
              options={banks}
              value=""
              placeholder={
                values.bank_identification_code !== ""
                  ? values.bank_identification_code?.split("/*?")[1]
                  : "Selecione"
              }
            />
            <Margin mb={10} />
            <Input
              max={5}
              maxLength={5}
              name="agency"
              size="large"
              placeholder="digite"
              label="Agência"
              value={values.agency}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, "");
                setFieldValue("agency", numericValue);
              }}
            />{" "}
            <Margin mb={10} />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
                rowGap: "30px",
                height: "400px",
              }}
            >
              <Input
                name="account_number"
                size="large"
                placeholder="digite"
                max={10}
                maxLength={10}
                label="Conta"
                value={values.account_number}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, "");
                  setFieldValue("account_number", numericValue);
                }}
              />
              <Input
                max={1}
                maxLength={1}
                size="large"
                label="Dígito"
                placeholder="digite"
                value={values.account_number_digit}
                name="account_number_digit"
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, "");
                  setFieldValue("account_number_digit", numericValue);
                }}
              />
            </div>
            <Footer>
              {" "}
              <div style={{ gridColumn: "span 6" }}>
                <Button
                  kind="ghost"
                  size="large"
                  onClick={() => handleClose()}
                  label="Cancelar"
                  icon={CloseIcon}
                />
              </div>
              <div style={{ gridColumn: "span 6" }}>
                <Button
                  kind="primary"
                  size="large"
                  icon={SaveIcon}
                  onClick={() => createBankAccount()}
                  label="Salvar"
                  disabled={
                    !values.account_number ||
                    !values.agency ||
                    !values.bank_identification_code ||
                    !values.account_number_digit
                  }
                />
              </div>
            </Footer>
          </div>
        </LateralModal>
      </div>
    </Container>
  );
};

export default ProductInfoCCB;
